//In the future we may utilize UserDefinedFields for a myriad of things.
export enum UserDefinedFieldType {
    MODELSPECIFICATION = "ModelSpecification",
    ADDITIONALDEALERPRICE = "AdditionalDealerPrice"
}